import { component } from '../../picoapp';
import { getClosest } from '../../utilities';


class Accordion {
  constructor(el, ctx) {
    this.ctx = ctx;
    this.identifier = el.dataset.identifier;
    this.init(el);
    this.bindEvents();
  }

  init(el) {
    this.el = el;
    this.items = el.querySelectorAll('.Accordion__item');
  }

  bindEvents() {
    this.items.forEach((element) => {
      element.addEventListener('click', (e) => {
        if (e.target.classList.contains('Accordion__toggle') || getClosest(e.target, '.Accordion__toggle')) {
          e.preventDefault();
          this.toggleItem(element);
        }
      });
    });
  }

  toggleItem(el) {
    el.classList.toggle('is-active');

    var optionsArray = Array.prototype.slice.call(this.items);
    var filteredArray = optionsArray.filter((item) => {
      return !item.isEqualNode(el)
    });
    filteredArray.forEach((el) => {
      el.classList.remove('is-active');
    });
  }

}

export default component((node, ctx) => {
  new Accordion(node, ctx);
});
